import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import './EditRule.css';
import { SectionWrap } from '../../Components';
import LoadingPage from '../LoadingPage/LoadingPage';


function EditRule() {
    // const apiUrl = 'http://localhost/server/testServer';
    const apiUrl = 'https://www.albarede.com/server';


    const { id } = useParams();
    const [ruleText, setRuleText] = useState('');
    const [lawType, setLawtype] = useState('');
    const [lawYear, setLawYear] = useState('');
    const [lawRef, setLawRef] = useState('');
    const [redirect, setRedirect] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // حالة التحميل

    useEffect(() => {
        setIsLoading(true);
        fetch(`${apiUrl}/rule.php?id=${id}`)
            .then((response) => response.json())
            .then((ruleInfo) => {
                setRuleText(ruleInfo.ruleText || '');
                setLawtype(ruleInfo.lawType || '');
                setLawYear(ruleInfo.lawYear || '');
                setLawRef(ruleInfo.lawRef || '');
                setIsLoading(false);
            })
            .catch((err) => console.error('Error fetching rule:', err));
    }, [id]);

    const updateRule = async (ev) => {
        ev.preventDefault();
        if (!ruleText || !lawType || !lawYear || !lawRef) {
            alert('Please fill out all required fields.');
            return;
        }
        const data = {
            ruleText,
            lawType,
            lawYear,
            lawRef,
        };
        try {
            const response = await fetch(`${apiUrl}/rule.php?id=${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
    
            if (!response.ok) {
                const error = await response.json();
                alert(`Error: ${error.error || 'Something went wrong'}`);
                return;
            }
    
            alert('Rule updated successfully.');
            setRedirect(true);
        } catch (err) {
            console.error('Error updating rule:', err);
            alert('Failed to update rule.');
        }
    };

    const handleDelete = async () => {
        const confirmed = window.confirm('هل أنت متأكد أنك تريد حذف هذا القانون؟');
        if (!confirmed) return;
    
        try {
            const response = await fetch(`${apiUrl}/rule.php`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `id=${id}`,
            });
    
            if (!response.ok) {
                const error = await response.json();
                alert(`Error: ${error.error || 'Failed to delete rule'}`);
                return;
            }
    
            alert('تم حذف القانون بنجاح');
            setRedirect(true);
        } catch (err) {
            console.error('Error deleting rule:', err);
            alert('حدث خطأ أثناء الحذف.');
        }
    };
    

    if (redirect) {
        return <Navigate to="/rules" />;
    }
    if (isLoading) {
        return <LoadingPage />; // عرض صفحة التحميل أثناء التحميل
      }

  return (
    <>
    <div className='createRule'>
                <SectionWrap>
            <form onSubmit={updateRule}>
                <h1>تعديل قانون</h1>
                <textarea type='text' 
                       placeholder={'النص القانون'} 
                       value={ruleText} 
                       onChange={(ev) => setRuleText(ev.target.value)}/>
                <input type='text' 
                       placeholder={'القانون (مدني جزائي ...الخ'} 
                       value={lawType} 
                       onChange={(ev) => setLawtype(ev.target.value)} />
                <input type='text' 
                       placeholder={'قرار'} 
                       value={lawYear} 
                       onChange={(ev) => setLawYear(ev.target.value)} />
                <input type='text' 
                       placeholder={'المصدر'} 
                       value={lawRef} 
                       onChange={(ev) => setLawRef(ev.target.value)} />
                <button type='submit' className='postBtn'>نشر</button>
                <button
                        type="button"
                        onClick={handleDelete}
                        className="postBtnDelet"
                    >
                        حذف
                    </button>
            </form>
            </SectionWrap>
            </div>
    </>
  )
}

export default EditRule